import get from 'lodash.get';
import {STATE_ABBREV_MAP} from "../config/const";
import { isPaymentKiosk } from './configSelectors';


export const getPickupAddresses = state => state.address.pickUpAddresses || [];

export const isDelivery = state => (isPaymentKiosk(state) ? false : state.address.isDelivery);

export const isAllowedAddressByZip = (state, zip) => {
  const allowedZipCodes = get(state, 'config.ALLOWED_ZIP_CODES', []);
  if ((Array.isArray(allowedZipCodes) 
      && allowedZipCodes.length !== 0) 
      || allowedZipCodes !== '[]'
      && allowedZipCodes.includes(zip)) {
    return true;
  }
  return false;
};

export const isForbiddenAddressByZip = (state, zip) => {
  const forbiddenZipCodes = get(state, 'config.FORBIDDEN_ZIP_CODES', []);
  if ((Array.isArray(forbiddenZipCodes) 
      && forbiddenZipCodes.length !== 0) 
      || forbiddenZipCodes !== '[]' 
      && forbiddenZipCodes.includes(zip)) {
    return true;
  }
  return false;
};

export const parseGoogleAddressToMasterCalcAddress = (googleAddress) => {
  if (!googleAddress) return null;

  return ({
    street1: googleAddress.street,
    city: googleAddress.city,
    county: (googleAddress.county || "").replace(" County", ""),
    zipcode: googleAddress.zip,
    stateAbbr: googleAddress.state,
    state: STATE_ABBREV_MAP[googleAddress.state],
    country: googleAddress.country
  })
};


export const getCurrentDeliveryAddress = (state) => {
  if (state.address && state.address.deliveryAddresses && !isNaN(state.address.currentAddressIdx)) {
    return (state.address.deliveryAddresses[state.address.currentAddressIdx] || {}).address
  }

  return null;
};


export const getCurrentDeliveryMasterCalcAddress = (state) => {
  if (!isDelivery(state)) {
    return null;
  }
  const currentDeliveryAddress = getCurrentDeliveryAddress(state);
  if (!currentDeliveryAddress) return null;

  return parseGoogleAddressToMasterCalcAddress(currentDeliveryAddress);
};


export const isAddressBarOpened = state => state.config.isEcommerceEnabled && state.address.isAddressBarOpen;



// WEBPACK FOOTER //
// ./src/selectors/address.js